import {setCityDirection} from '../i18n';
import type { HouseData, ContactLinks } from "../api/types";
import { CityApi } from "../api/client";

const contacts: Array<[keyof ContactLinks,string,string]> = [
  ["twitter","X / Twitter","https://x.com/username"],
  ["linkedin","LinkedIn","https://www.linkedin.com/in/username"],
  ["instagram","Instagram","https://www.instagram.com/username"],
  ["telegram","Telegram","https://t.me/username"],
  ["gmail","Gmail","name@gmail.com"],
  ["website","وب‌سایت شخصی — نیازمند تأیید مدیر","https://example.com"],
];

export function contactList(values:ContactLinks|undefined):HTMLElement {
  const list=document.createElement("div");list.className="resident-contacts";
  for (const [key,label] of contacts) {
    const value=values?.[key];if(typeof value!=="string"||!value)continue;
    if (key==="website"&&!values?.websiteApproved)continue;
    const link=document.createElement("a");link.textContent=label;link.href=key==="gmail"?`mailto:${value}`:value;
    link.target="_blank";link.rel="noopener noreferrer";list.append(link);
  }
  if(!list.childElementCount){const empty=document.createElement("p");empty.textContent="اطلاعات تماس عمومی ثبت نشده است.";list.append(empty);}
  return list;
}

export class ResidentStudio {
  private root=document.createElement("div");
  constructor(private api:CityApi,private changed:(house:HouseData)=>void){
    this.root.className="city-modal resident-studio";setCityDirection(this.root);
    this.root.hidden=true;
    document.body.append(this.root);
  }
  destroy():void{this.root.remove();}
  open(house:HouseData,isAdmin=false):void {
    this.root.replaceChildren();this.root.hidden=false;document.body.classList.add("city-modal-open");
    const panel=document.createElement("section");panel.className="city-modal__panel resident-studio__panel";
    const heading=document.createElement("header");heading.className="city-modal__header";
    const title=document.createElement("strong");title.textContent="اطلاعات تماس";
    const close=document.createElement("button");close.type="button";close.className="city-modal__close";close.textContent="×";
    const closeModal=()=>{this.root.hidden=true;document.body.classList.remove("city-modal-open");};
    close.onclick=closeModal;heading.append(title,close);
    const form=document.createElement("form");form.className="resident-studio__form resident-studio__form--contacts";
    const links=document.createElement("section");links.className="resident-studio__contacts";
    const inputs=new Map<string,HTMLInputElement>();
    for(const section of ["owner","business"] as const){
      const fieldset=document.createElement("fieldset");const legend=document.createElement("legend");legend.textContent=section==="owner"?"اطلاعات عمومی مالک (روی آواتار)":"اطلاعات کسب‌وکار (روی مغازه)";fieldset.append(legend);
      for(const [key,label,placeholder] of contacts){
        const row=document.createElement("label");row.textContent=label;const control=document.createElement("input");control.type=key==="gmail"?"email":"url";control.placeholder=placeholder;control.value=String(house.contacts?.[section]?.[key]??"");control.dir="ltr";row.append(control);fieldset.append(row);inputs.set(`${section}:${key}`,control);
      }
      if(isAdmin){const approved=document.createElement("input");approved.type="checkbox";approved.checked=!!house.contacts?.[section]?.websiteApproved;const row=document.createElement("label");row.append(approved,document.createTextNode(" تأیید سایت شخصی"));fieldset.append(row);inputs.set(`${section}:websiteApproved`,approved);}
      links.append(fieldset);
    }
    const status=document.createElement("p");status.className="city-modal__notice";status.hidden=true;
    const save=document.createElement("button");save.type="submit";save.className="city-btn city-btn--primary";save.textContent="ذخیره اطلاعات تماس";
    form.onsubmit=async event=>{event.preventDefault();save.disabled=true;status.hidden=false;status.textContent="در حال ذخیره…";
      try {
        const data:{owner:ContactLinks;business:ContactLinks}={owner:{},business:{}};
        for(const [id,control] of inputs){const [section,key]=id.split(":") as ["owner"|"business",keyof ContactLinks];(data[section] as Record<string,unknown>)[key]=key==="websiteApproved"?control.checked:control.value.trim();}
        const result=await this.api.saveResident(house.externalId,{contacts:data});Object.assign(house,result.storefront);this.changed(house);status.textContent="اطلاعات تماس ذخیره شد.";
      }catch(error){status.textContent=error instanceof Error?error.message:"ذخیره انجام نشد.";}finally{save.disabled=false;}
    };
    form.append(links,status,save);panel.append(heading,form);this.root.append(panel);close.focus();
  }
}
